// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f5VI","content":"styles_content__Fh_rW","tableWrap":"styles_tableWrap__1pXSF"};